import { Link } from 'react-router-dom';
import ArticleListCard from './ArticleListCard';
import { LoadingState, ErrorState } from '../../../components';
import './RecentArticlesList.css';

function RecentArticlesList({ articles = [], loading = false, error = null }) {
  if (loading) {
    return (
      <div className="recent-articles-list">
        <h2>Articoli Recenti</h2>
        <LoadingState message="Caricamento articoli..." className="compact" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="recent-articles-list">
        <h2>Articoli Recenti</h2>
        <ErrorState message={error} className="compact" />
      </div>
    );
  }

  // Get the 5 most recent articles
  const recentArticles = articles
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 5);

  if (recentArticles.length === 0) return null;

  return (
    <div className="recent-articles-list">
      <h2>Articoli Recenti</h2>
      <ul className="articles-list">
        {recentArticles.map(article => (
          <li key={article.id} className="article-list-item">
            <ArticleListCard
              id={article.id}
              title={article.title}
              excerpt={article.excerpt}
              date={article.date}
              imageUrl={article.imageUrl}
            />
          </li>
        ))}
      </ul>
      <Link to="/articles" className="view-all-link">
        Vedi tutti gli articoli →
      </Link>
    </div>
  );
}

export default RecentArticlesList;
